import {del, post} from "./request";
import {protectedAxiosInstance} from "./AxiosInstance";

const apiResource = "/fileUpload";
export const fileApi = {};

fileApi.add = async (payload, onUploadProgress) => {
  try {
    if (onUploadProgress) {
      const response = await protectedAxiosInstance.post(
        `/api${apiResource}/add`,
        payload,
        {onUploadProgress},
      );
      return response.data;
    }
    const {data} = await post(apiResource + "/add", payload);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

fileApi.delete = async ({id}) => {
  try {
    const {data} = await del(apiResource + "/delete/" + id);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
